<template>
    <div onclick="event.preventDefault();">
        <span class="link text-primary" @click.prevent="displayForm"> <i class="fas fa-cogs"></i>&nbsp;
            Configurações</span>
        <b-modal title="Configurações" size="lg" v-model="modalpassword">
            <b-card no-body class="p-4 mb-3">
                <b-row class="text-center">
                    <b-col class="text-center">
                        <b-avatar size="150px" :src="file.avatar"></b-avatar>
                    </b-col>
                </b-row>
                <b-row align-h="center" class="text-center mt-2 mb-3">
                    <b-col class="col-md-10">
                        <b-button v-if="file.avatar" variant="danger" size="sm" class="mt-1"
                            @click="removeImage('avatar')">
                            Remover Imagem
                        </b-button>
                        <b-form-file v-else placeholder="Adicionar Imagem" no-drop accept=".jpg, .png, .jpeg"
                            @change="onFileChange($event, 'avatar')" browse-text="Procurar" v-model="imagem" />
                    </b-col>
                </b-row>
                <br>
                <b-row class="mt-3" v-if="isDistribuidor">
                    <b-col>
                        <label for=""><i class="fab fa-whatsapp"></i> WhatsApp</label>
                        <b-form-input v-mask="['(##) ####-####', '(##) #####-####']" id="telefone1" v-model="whatsapp"
                        placeholder="Numero"></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col cols="6">
                        <b-form-group id="input-group-1" label="Nova Senha" label-for="password">
                            <b-form-input id="password" type="password" v-model="password" required :state="validation">
                            </b-form-input>
                            <b-form-invalid-feedback :state="validation">
                                {{ passwordError }}
                            </b-form-invalid-feedback>
                            <b-form-valid-feedback :state="validation">
                                Senha Válida
                            </b-form-valid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-1" label="Confirme a Senha" label-for="confirm">
                            <b-form-input id="confirm" type="password" v-model="confirm_password" required
                                :state="validationConfirm">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col cols="6">
                        <b-form-group id="input-group-1" label="E-mail" label-for="mail">
                            <b-form-input id="mail" type="email" v-model="email" required :state="validateEmail">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <!-- Chamado - 11255 - Campo nome_fantasia - classe "P" -->
                     <b-col cols="6" v-if="isDistribuidorClass === 'P'">
                        <b-form-group id="input-group-1" label="Nome Fantasia" label-for="mail">
                            <b-form-input  id="nome_fantasia" type="text" v-model="nome_fantasia"
                             required :state="validateNomeFantasia" placeholder="Nome Fantasia">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                
                <b-row class="mt-3 justify-content-end">
                    <b-button @click="save" variant="primary" class="float-right mr-3">Salvar</b-button>
                </b-row>
            </b-card>
            <b-card>
                <b-row>
                    <b-col cols="12" class="text-center mb-2">
                        <h5>Favoritos (Barra de Navegação)</h5>
                    </b-col>
                    <b-col cols='12' class="mb-3 d-flex">
                        <b-select v-model="selected" :disabled="maxItems" :options="menus" />
                        <b-button @click="addFavoritos" :disabled="maxItems" class="mx-2"><i
                                class="fas fa-plus"></i></b-button>
                    </b-col>
                    <b-col cols="12" style="max-height: 129px;" class="overflow-auto">
                        <div class="d-flex justify-content-center flex-wrap">
                            <b-form-tag v-for="(select, index) in favoritos" @remove="removeTag(index)" :key="index"
                                :title="select.label" class="m-1">{{ index + ' - ' + select.label }}</b-form-tag>
                        </div>
                    </b-col>
                    <b-col cols='12' class="mt-3 text-right">
                        <b-button @click="saveFavorites" variant="primary" class="float-right">Salvar</b-button>
                    </b-col>
                </b-row>
            </b-card>
            <template #modal-footer>
                <div class="w-100">
                    <b-button variant="danger" size="sm" class="float-right" @click="displayForm">Fechar</b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "password",
    data() {
        return {
            isDistribuidor: null,
            isDistribuidorClass: null,
            path: '',
            imagem: [],
            file: {
                avatar: ''
            },
            showForm: false,
            password: "",
            confirm_password: "",
            whatsapp: '',
            selected: '',
            favoritos: [],
            menus: [],
            modalpassword: false,
            passwordError: "",
            email: "",
            nome_fantasia: ""
        }
    },
    computed: {
        validateEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.email);
        },
        validateNomeFantasia(){
            return this.nome_fantasia && this.nome_fantasia.length > 2;
        },
        maxItems() {
            if (this.favoritos.length >= 5) {
                return true
            } else {
                return false
            }
        },
        validationConfirm() {
            if(this.password){
                return this.password !== '' && this.password == this.confirm_password
            } else {
                return true
            }
        },
        validation() {
            if(!this.password){
                return true;
            }
            const rules = [
                { test: /.{8,}/, message: "A senha deve ter pelo menos 8 caracteres." },
                { test: /[A-z]/, message: "A senha deve ter pelo menos uma letra." },
                { test: /[0-9]/, message: "A senha deve ter pelo menos um número." }
                //{ test: /[@$!%*?&#]/, message: "A senha deve ter pelo menos um caractere especial." },
            ];
            for (const rule of rules) {
                if (!rule.test.test(this.password)) {
                    this.passwordError = rule.message;
                    return false;
                }
            }
            this.passwordError = "";
            return true;
        }
    },
    mounted() {
        this.getMenus()
        this.getMenusFavorites()
    },

    methods: {
        getMenusFavorites() {
            axios
                .get("/get_favorites")
                .then(resp => {
                    if (resp.data) {
                        resp.data.forEach(element => {
                            if (element.menu) {
                                this.favoritos.push(element.menu)
                            } else {
                                this.favoritos.push(element)
                            }
                        })
                    }
                })
                .catch(error => {

                })
        },
        addFavoritos() {
            const find = this.favoritos.find((a) => a.id == this.selected.id)

            if (!find && this.selected) {
                this.favoritos.push(this.selected)
            }
        },
        saveFavorites() {
            const obj = {
                'menus': this.favoritos
            }

            axios
                .post("/adm/save_favorites", obj)
                .then(resp => {
                    location.reload()
                })
                .catch(error => {

                })

        },
        removeTag(index) {
            this.favoritos.splice(index, 1)
        },
        getMenus() {
            axios
                .get("/get_menus")
                .then(resp => {
                    if (resp.data) {
                        var obj = {}
                        resp.data.forEach(element => {
                            obj = {
                                text: element.label,
                                value: element
                            }

                            this.menus.push(obj)
                        })
                    }
                })
                .catch(error => {

                })
        },
        removeImage(keyImage) {
            this.file[keyImage] = '';
        },
        onFileChange(e, image) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            this.createImage(files[0], image);
        },
        createImage(file, keyImage) {
            //console.log(keyImage);
            var reader = new FileReader();
            var vm = this;
            var keyImage = keyImage;

            reader.onload = (e) => {
                vm.file[keyImage] = e.target.result;
            };
            reader.readAsDataURL(file);
            //console.log(this.file)
        },
        getPath() {
            const vm = this;
            axios.get('/user/getPath')
                .then((response) => {
                    vm.file.avatar = response.data.path;
                    vm.whatsapp = response.data.whatsapp;
                    vm.isDistribuidor = response.data.isDistribuidor;
                    vm.email = response.data.email;
                    vm.isDistribuidorClass = response.data.classe;
                    vm.nome_fantasia = response.data.nome_fantasia;
                    vm.original_nome_fantasia = response.data.nome_fantasia;
                })
        },
        displayForm(event) {
            this.modalpassword = !this.modalpassword;
            if (this.modalpassword && !this.file.avatar) {
                this.getPath();
            }
            this.clearForm();
        },
        save() {
            const vm = this;
            if (!this.validation) {
                return vm.$swal({
                    title: "Atenção",
                    text: "A nova senha não atende aos requisitos mínimos de senha",
                    icon: "error",
                });
            }
            if (!this.validationConfirm) {
                return vm.$swal({
                    title: "Atenção",
                    text: "A confirmação de senha é diferente da nova senha",
                    icon: "error",
                });
            }
            if(!this.validateEmail){
                return vm.$swal({
                    title: "Atenção",
                    text: "E-mail inválido",
                    icon: "error",
                });
            }
            // Valida Nome Fantasia apenas classe for 'P'
            if(this.isDistribuidorClass === 'P'){
                if(this.nome_fantasia === this.original_nome_fantasia){
                    return vm.$swal({
                        title: "Atenção",
                        text: "Nome Fantasia não pode ser igual a atual",
                        icon: "error",
                    });
                }
                if(!this.validateNomeFantasia){
                    return vm.$swal({
                        title: "Atenção",
                        text: "Nome Fantasia inválido",
                        icon: "error",
                    });
                }
            }
            let form = new FormData();
            form.append("imagem", this.imagem);
            form.append("senha", this.password);
            form.append("senha_confirmation", this.confirm_password);
            form.append("whatsapp", this.whatsapp);
            form.append("email", this.email);
            form.append("nome_fantasia", this.nome_fantasia);

            $('.loading').show();
            // console.log(this.file);
            axios.post('/adm/users/change', form)
                .then((response) => {
                    vm.$swal('OK', response.data.success, 'success');
                    vm.showForm = false;
                    vm.displayForm();
                }).catch((error) => {
                    alert(error.response.data.errors.join('\n'));
                    console.log(error.response.data);
                }).finally(() => {
                    $('.loading').hide();
                });
        },
        clearForm() {
            this.password = "";
            this.confirm_password = "";
        }
    },

}
</script>


<style scoped>
.form-password {
    padding: 11px 10px;
    width: 300px;
}

.link {
    padding: 10px 20px;
    cursor: pointer;

}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/util/Password.vue